import { render, staticRenderFns } from "./BlockReservation.vue?vue&type=template&id=2b7b1e94&"
import script from "./BlockReservation.vue?vue&type=script&lang=js&"
export * from "./BlockReservation.vue?vue&type=script&lang=js&"
import style0 from "./BlockReservation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
